import LogRocket from 'logrocket';

export function initLogRocketStepOne() {
  if (!window.materio?.logrocket?.enabled) {
    return; // No-Op; LogRocket is disabled
  }

  // Backwards compatibility with CDN (which sets LogRocket on window)
  window.LogRocket = LogRocket;

  LogRocket.init(window.materio.logrocket.appId, {
    network: {
      requestSanitizer: (request) => {
        const url = (request.url || '').toLowerCase();

        // Prevent monitoring tools from causing an infinite "Ping-Pong" by monitoring each other
        if (url.indexOf('api-js.mixpanel.com') !== -1) {
          return null;
        } else if (url.indexOf('ingest.sentry.io') !== -1) {
          return null;
        }

        // if the url contains 'register' or 'login', scrub out the body
        if (url.indexOf('register') !== -1 || url.indexOf('login') !== -1) {
          request.body = null;
        }

        return request; // otherwise log the request normally
      },
    },
  });

  if (window.MATERIO_UNSUPPORTED_BROWSER_DETECTED) {
    LogRocket.captureMessage('Unsupported browser feature detected', {
      tags: { eng: 'teddy', issue: 'unsupported-browser-feature' },
      extra: { ...window.MATERIO_UNSUPPORTED_BROWSER_DETAILS },
    });
  }
}
